document.addEventListener("DOMContentLoaded", function () {
  // =========================
  // Email & phone labels
  // =========================

  document
    .querySelectorAll('a[href^="mailto:"], a[href^="tel:"]')
    .forEach(function (el) {
      const href = el.getAttribute("href");
      if (
        el.getAttribute("role") === "button" ||
        el.classList.contains("button") ||
        el.classList.contains("btn")
      ) {
        return;
      }

      if (href && href.startsWith("mailto:")) {
        const email = href.replace("mailto:", "").trim();
        const existing = el.getAttribute("aria-label");

        if (existing) {
          el.setAttribute("aria-label", existing + ", Email address: " + email);
        } else {
          el.setAttribute("aria-label", "Email address: " + email);
        }
      }

      // TEL
      if (href && href.startsWith("tel:")) {
        const existing = el.getAttribute("aria-label");

        if (existing) {
          return;
        }

        const text = el.textContent.trim();
        el.setAttribute("aria-label", "Phone number: " + text);
      }
    });

  // =========================
  // Third party warning
  // =========================
  const warningText =
    "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      const linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch {
      return false;
    }
  }
  function handleExternalLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      const href = link.getAttribute("href");
      if (!href || !isThirdParty(href)) return;

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      const img = link.querySelector("img");

      // if (img) {
      //   link.removeAttribute("aria-label");

      //   let alt = img.getAttribute("alt") || "";
      //   if (!alt.includes(warningText)) {
      //     img.setAttribute("alt", alt ? alt + ", " + warningText : warningText);
      //   }
      //   return;
      // }

      const aria = link.getAttribute("aria-label");
      const text = link.textContent.trim();

      if (aria) {
        if (!aria.includes(warningText)) {
          link.setAttribute("aria-label", aria + ", " + warningText);
        }
      } else {
        if (!text) return;

        link.setAttribute("aria-label", text + ", " + warningText);
      }
    });
  }
  setTimeout(handleExternalLinks, 500);

  // =========================
  // internal links fixes
  // =========================
  function isInternalLink(href) {
    try {
      const linkUrl = new URL(href, window.location.href);
      return linkUrl.hostname === window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  function removeTargetRelFromInternalLinks() {
    document
      .querySelectorAll('a[target="_blank"], a[rel]')
      .forEach(function (link) {
        const href = link.getAttribute("href");

        if (!href) return;
        if (
          href.startsWith("mailto:") ||
          href.startsWith("tel:") ||
          href.startsWith("#") ||
          href.startsWith("javascript:")
        ) {
          return;
        }
        if (isInternalLink(href)) {
          link.removeAttribute("target");
          link.removeAttribute("rel");
        }
      });
  }
  removeTargetRelFromInternalLinks();

  // =========================
  // Search pop-up sr update
  // =========================
  function initSearchPopupAccessibility() {
    const searchButton = document.querySelector(".sf-search-form button");
    const searchPopup = document.querySelector(".search-popup");
    const closeSearchButton = document.querySelector(".close-search-btn");
    const searchInput = searchPopup?.querySelector("input");

    if (!searchButton || !searchPopup || !closeSearchButton || !searchInput)
      return;

    function closeSearchPopup() {
      searchPopup.classList.add("opacity-0");

      setTimeout(() => {
        searchPopup.classList.add("invisible");
        searchButton.focus();
      }, 100);
    }

    searchButton.addEventListener("click", function () {
      searchPopup.classList.remove("invisible");
      searchPopup.classList.remove("opacity-0");
      searchPopup.classList.add("opacity-100");

      setTimeout(() => {
        searchInput.focus();
      }, 100);
    });
    closeSearchButton.addEventListener("click", function () {
      closeSearchPopup();
    });
    document.addEventListener("keydown", function (event) {
      if (
        event.key === "Escape" &&
        !searchPopup.classList.contains("invisible")
      ) {
        closeSearchPopup();
      }
    });
  }
  initSearchPopupAccessibility();

  // =========================
  // Cart focus management
  // =========================
  function initCartDrawerAccessibility() {
    const drawerSelector = "#shopify-section-cart-drawer .scd__wrapper";
    const closeSelector = "button.scd__close";
    const triggerSelector = "button.add-to-cart, a.sf-cart-icon";

    if (window.cartDrawerAccessibilityInitialized) return;
    window.cartDrawerAccessibilityInitialized = true;

    let cartDrawer = null;
    let drawerWasOpen = false;
    let lastTrigger = null;
    let drawerObserver = null;
    let focusTimer = null;

    function restoreTriggerFocus() {
      window.clearTimeout(focusTimer);

      focusTimer = window.setTimeout(function () {
        if (
          lastTrigger &&
          lastTrigger.isConnected &&
          typeof lastTrigger.focus === "function"
        ) {
          lastTrigger.focus();
        }
      }, 200);
    }

    function checkDrawerState() {
      if (!cartDrawer) return;

      const isOpen = !cartDrawer.classList.contains("hidden");

      if (isOpen && !drawerWasOpen) {
        drawerWasOpen = true;
        window.clearTimeout(focusTimer);

        focusTimer = window.setTimeout(function () {
          // Confirm the drawer is still open before moving focus.
          if (cartDrawer && !cartDrawer.classList.contains("hidden")) {
            const closeButton = cartDrawer.querySelector(closeSelector);

            if (closeButton) {
              closeButton.focus();
            }
          }
        }, 200);
      }

      if (!isOpen && drawerWasOpen) {
        drawerWasOpen = false;
        restoreTriggerFocus();
      }
    }

    function observeDrawer(drawer) {
      if (!drawer || drawer === cartDrawer) return;

      if (drawerObserver) {
        drawerObserver.disconnect();
      }

      cartDrawer = drawer;
      drawerWasOpen = false;

      drawerObserver = new MutationObserver(checkDrawerState);

      drawerObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ["class"],
      });

      checkDrawerState();
    }

    document.addEventListener(
      "click",
      function (event) {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest(triggerSelector);

        if (trigger) {
          lastTrigger = trigger;
        }
      },
      true,
    );

    document.addEventListener("keydown", function (event) {
      if (
        event.key !== "Escape" ||
        !cartDrawer ||
        cartDrawer.classList.contains("hidden")
      ) {
        return;
      }

      const closeButton = cartDrawer.querySelector(closeSelector);

      if (closeButton) {
        event.preventDefault();
        closeButton.click();
      }
    });

    const insertionObserver = new MutationObserver(function () {
      const drawer = document.querySelector(drawerSelector);

      if (drawer && drawer !== cartDrawer) {
        observeDrawer(drawer);
      }
    });

    insertionObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    observeDrawer(document.querySelector(drawerSelector));
  }

  initCartDrawerAccessibility();

  // =========================
  // Clickable desktop menu
  // =========================
  function initClickableDesktopMenu() {
    const header = document.querySelector("section.sf-header");
    if (!header) return;

    const triggers = header.querySelectorAll(
      '.sf-header__desktop .sf__parent-item[role="button"][aria-expanded]',
    );

    let openedTrigger = null;

    function closeMenu(trigger, returnFocus = false) {
      if (!trigger) return;

      trigger.setAttribute("aria-expanded", "false");
      trigger
        .closest(".sf-menu-item")
        ?.classList.remove("sf-menu-item--active");

      header.classList.remove("sf-mega-active");
      header.classList.remove("sf-mega-active-clone");

      if (openedTrigger === trigger) openedTrigger = null;
      if (returnFocus) trigger.focus();
    }

    function openMenu(trigger) {
      const item = trigger.closest(".sf-menu-item");
      const submenu = item?.querySelector(
        ":scope > .sf-menu__desktop-sub-menu",
      );

      if (!item || !submenu) return;

      if (openedTrigger) closeMenu(openedTrigger);

      const size = submenu.getBoundingClientRect();
      header.style.setProperty("--sf-dropdown-width", size.width);
      header.style.setProperty("--sf-dropdown-height", size.height);

      trigger.setAttribute("aria-expanded", "true");
      item.classList.add("sf-menu-item--active");
      header.classList.add("sf-mega-active");
      header.classList.add("sf-mega-active-clone");
      openedTrigger = trigger;
    }

    triggers.forEach(function (trigger, index) {
      const item = trigger.closest(".sf-menu-item");
      const submenu = item?.querySelector(
        ":scope > .sf-menu__desktop-sub-menu",
      );

      if (!submenu) return;

      trigger.setAttribute("tabindex", "0");

      if (!submenu.id) submenu.id = "desktop-submenu-" + index;
      trigger.setAttribute("aria-controls", submenu.id);

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        openedTrigger === trigger ? closeMenu(trigger) : openMenu(trigger);
      });

      trigger.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          trigger.click();
        }
      });

      item.addEventListener(
        "mouseleave",
        function (event) {
          if (openedTrigger === trigger) {
            event.stopImmediatePropagation();
          }
        },
        true,
      );
    });

    document.addEventListener("click", function (event) {
      if (openedTrigger && !header.contains(event.target)) {
        closeMenu(openedTrigger);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && openedTrigger) {
        closeMenu(openedTrigger, true);
      }
    });
    // Close menu when focus leaves the submenu
    header.addEventListener("focusout", function (event) {
      if (!openedTrigger) return;

      const submenu = openedTrigger
        .closest(".sf-menu-item")
        ?.querySelector(".sf-menu__desktop-sub-menu");

      if (!submenu) return;

      setTimeout(() => {
        const newFocus = document.activeElement;

        // If focus moved outside submenu and trigger, close menu
        if (!submenu.contains(newFocus) && !openedTrigger.contains(newFocus)) {
          closeMenu(openedTrigger);
        }
      }, 50);
    });
  }

  initClickableDesktopMenu();

  // =========================
  // Testominal slider
  // =========================
  (function () {
    function updateSwiperA11y() {
      document
        .querySelectorAll(
          "m-testimonials .swiper-slide, .sf-icon-box .section-my .swiper-slide",
        )
        .forEach(function (slide) {
          let active = false;

          const slider = slide.closest(".sf-icon-box .section-my");

          if (slider) {
            const slides = [...slider.querySelectorAll(".swiper-slide")];
            const activeIndex = slides.findIndex((s) =>
              s.classList.contains("swiper-slide-active"),
            );

            const currentIndex = slides.indexOf(slide);

            active =
              currentIndex >= activeIndex && currentIndex <= activeIndex + 2;
          } else {
            active =
              slide.classList.contains("swiper-slide-active") ||
              slide.classList.contains("swiper-slide-next") ||
              slide.classList.contains("swiper-slide-prev");
          }

          slide.setAttribute("aria-hidden", active ? "false" : "true");

          slide
            .querySelectorAll("a,button,input,select,textarea,[tabindex]")
            .forEach(function (el) {
              el.setAttribute("tabindex", active ? "0" : "-1");
              el.setAttribute("aria-hidden", active ? "false" : "true");
            });
        });
    }

    updateSwiperA11y();

    document.querySelectorAll(".swiper-container").forEach(function (swiper) {
      swiper.addEventListener("transitionend", updateSwiperA11y);
    });

    setInterval(updateSwiperA11y, 500);
  })();

  // =========================
  // other js
  // =========================
  //aria-expanded
  document.querySelectorAll(".select-selected").forEach(function (el) {
    new MutationObserver(function () {
      el.setAttribute(
        "aria-expanded",
        el.classList.contains("select-arrow-active") ? "true" : "false",
      );
    }).observe(el, { attributes: true, attributeFilter: ["class"] });
  });

  //aria-expanded on state on the filter button
  function initFilterAccordionAria() {
    document
      .querySelectorAll(".sf__accordion-item")
      .forEach(function (accordionItem) {
        const button = accordionItem.querySelector(
          ".filter-btn.sf__accordion-button",
        );
        if (!button) return;
        new MutationObserver(function () {
          button.setAttribute(
            "aria-expanded",
            accordionItem.classList.contains("open") ? "true" : "false",
          );
        }).observe(accordionItem, {
          attributes: true,
          attributeFilter: ["class"],
        });
      });
  }
  initFilterAccordionAria();
  //add role to the country selector
  document
    .querySelectorAll(
      ".sf-currency-switcher .select-selected, .sf-language-switcher .select-selected",
    )
    .forEach(function (el) {
      el.setAttribute("role", "button");
      el.setAttribute("aria-expanded", "false");
    });

  //icon hidden
  document
    .querySelectorAll(".sf-icon-box__icon .sf-image.w-full")
    .forEach(function (img) {
      img.setAttribute("aria-hidden", "true");
    });
  // adding aria hidden true on <hr> and <br>
  document.querySelectorAll("hr, br").forEach(function (element) {
    element.setAttribute("aria-hidden", "true");
  });
  // empty heading for section
  document
    .querySelectorAll(".sf-custom__block-inner h2.content__heading")
    .forEach(function (heading) {
      if (heading.textContent.trim() === "") {
        heading.remove();
      }
    });

  //for product gallery
  (function () {
    const containerSelector = ".f-media-desktop.swiper-container-initialized";
    const slideSelector = ".swiper-slide.sf-prod-media-item";

    function updateAriaHidden(container) {
      const slides = container.querySelectorAll(slideSelector);

      slides.forEach((slide) => {
        const img = slide.querySelector("img");
        if (!img) return;

        const isVisible =
          slide.classList.contains("swiper-slide-active") ||
          slide.classList.contains("swiper-slide-duplicate-active");

        if (isVisible) {
          img.removeAttribute("aria-hidden");
        } else {
          img.setAttribute("aria-hidden", "true");
        }
      });
    }

    function watchSlideChanges(container) {
      updateAriaHidden(container);

      const observer = new MutationObserver((mutations) => {
        const shouldUpdate = mutations.some(
          (m) =>
            m.type === "attributes" &&
            m.attributeName === "class" &&
            m.target.classList?.contains("sf-prod-media-item"),
        );
        if (shouldUpdate) updateAriaHidden(container);
      });

      observer.observe(container, {
        attributes: true,
        attributeFilter: ["class"],
        subtree: true,
      });
    }

    function init() {
      const existing = document.querySelector(containerSelector);
      if (existing) {
        watchSlideChanges(existing);
        return;
      }

      const bodyObserver = new MutationObserver((mutations, obs) => {
        const container = document.querySelector(containerSelector);
        if (container) {
          obs.disconnect();
          watchSlideChanges(container);
        }
      });

      bodyObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();

  // =========================
  // Mobile menu accessibility
  // =========================
  (function () {
    var menuButton = document.querySelector("a.sf-menu-button");
    var menuWrapper = document.querySelector(
      ".sf-menu-wrapper.sf-menu-wrapper-mobile",
    );
    var menuContent =
      menuWrapper && menuWrapper.querySelector(".sf-menu__content");
    var menuInner =
      menuWrapper && menuWrapper.querySelector(".sf-menu-content");

    if (!menuButton || !menuWrapper || !menuContent) return;

    if (!menuButton.hasAttribute("tabindex")) {
      menuButton.setAttribute("tabindex", "0");
    }

    if (!menuContent.id) {
      menuContent.id = "sf-mobile-menu-panel";
    }
    menuButton.setAttribute("aria-controls", menuContent.id);

    menuWrapper
      .querySelectorAll(".sf__toggle-submenu-mb")
      .forEach(function (toggle) {
        if (!toggle.hasAttribute("tabindex")) {
          toggle.setAttribute("tabindex", "0");
        }
      });

    function focusFirst(container) {
      var candidates = container.querySelectorAll(
        "button:not([disabled]), [href], input:not([disabled]), " +
          "select:not([disabled]), textarea:not([disabled]), " +
          '[tabindex]:not([tabindex="-1"])',
      );
      var first = Array.prototype.find.call(candidates, function (el) {
        return !el.closest(".hidden") && !el.closest(".-translate-x-full");
      });
      if (first) {
        first.focus();
      } else {
        container.setAttribute("tabindex", "-1");
        container.focus();
      }
    }

    function resetSubToggles() {
      menuWrapper
        .querySelectorAll(".sf__toggle-submenu-mb")
        .forEach(function (t) {
          t.setAttribute("aria-expanded", "false");
        });
    }

    // NEW: fully collapse every nested submenu panel back to its closed state,
    // regardless of how many levels deep the user had navigated.
    function collapseAllSubPanels() {
      menuWrapper.querySelectorAll(".sf-sub-links").forEach(function (panel) {
        panel.classList.add("hidden");
        panel._sfOpener = null;
      });

      if (menuInner) {
        // Strip any "open-level-N" tracking classes plus the generic flag,
        // e.g. open-level-1, open-level-2, sf-sub-menu-open
        var toRemove = [];
        menuInner.classList.forEach(function (cls) {
          if (cls === "sf-sub-menu-open" || /^open-level-\d+$/.test(cls)) {
            toRemove.push(cls);
          }
        });
        toRemove.forEach(function (cls) {
          menuInner.classList.remove(cls);
        });
      }
    }

    // NEW: single source of truth for closing the whole drawer.
    function closeDrawer() {
      collapseAllSubPanels();

      menuContent.classList.add("-translate-x-full");
      menuWrapper.style.setProperty("--tw-bg-opacity", "0");
      menuWrapper.classList.add("hidden");

      resetSubToggles();

      setTimeout(function () {
        menuButton.setAttribute("aria-expanded", "false");
        menuButton.focus();
      }, 320);
    }

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== "class") return;

        var isOpen = !menuContent.classList.contains("-translate-x-full");

        if (isOpen) {
          menuButton.setAttribute("aria-expanded", "true");
          setTimeout(function () {
            focusFirst(menuContent);
          }, 320);
        } else {
          menuButton.setAttribute("aria-expanded", "false");
          resetSubToggles();
        }
      });
    }).observe(menuContent, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // CHANGED: close button now always fully resets the drawer,
    // no matter which nested level it was clicked from.
    menuWrapper.addEventListener("click", function (event) {
      var closeBtn = event.target.closest("button.close-menu-drawer");
      if (!closeBtn) return;

      closeDrawer();
    });

    menuWrapper.addEventListener("click", function (event) {
      var toggle = event.target.closest(".sf__toggle-submenu-mb");
      if (!toggle) return;

      var parentLi = toggle.closest("li");
      var subPanel =
        parentLi && parentLi.querySelector(":scope > .sf-sub-links");
      if (!subPanel) return;

      subPanel._sfOpener = toggle;

      if (!subPanel.classList.contains("hidden")) {
        toggle.setAttribute("aria-expanded", "true");
        var immediateBack = subPanel.querySelector("button.back");
        if (immediateBack) immediateBack.focus();
        return;
      }

      var obs = new MutationObserver(function (mutations, observer) {
        var opened = mutations.some(function (m) {
          return (
            m.attributeName === "class" &&
            !subPanel.classList.contains("hidden")
          );
        });
        if (!opened) return;

        observer.disconnect();
        toggle.setAttribute("aria-expanded", "true");

        var backBtn = subPanel.querySelector("button.back");
        if (backBtn) backBtn.focus();
      });

      obs.observe(subPanel, { attributes: true, attributeFilter: ["class"] });
      setTimeout(function () {
        obs.disconnect();
      }, 600);
    });

    menuWrapper.addEventListener("click", function (event) {
      var backBtn = event.target.closest("button.back");
      if (!backBtn) return;

      var subPanel = backBtn.closest(".sf-sub-links");
      if (!subPanel) return;

      var targetToggle = subPanel._sfOpener;

      if (!targetToggle) {
        var parentLi = subPanel.parentElement;
        targetToggle = parentLi
          ? parentLi.querySelector(":scope > .sf__toggle-submenu-mb")
          : null;
      }
      var focusTarget = targetToggle; // capture for closure
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (focusTarget && focusTarget.isConnected) {
            focusTarget.setAttribute("aria-expanded", "false");
            focusTarget.focus();
          } else {
            focusFirst(menuContent);
          }
        });
      });
    });

    menuWrapper.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;

      var toggle = event.target.closest(".sf__toggle-submenu-mb");
      if (toggle) {
        event.preventDefault();
        toggle.click();
        return;
      }
      var hamburger = event.target.closest("a.sf-menu-button");
      if (hamburger) {
        event.preventDefault();
        hamburger.click();
      }
    });

    // NEW: Escape key also fully closes the drawer from any nested level.
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (menuWrapper.classList.contains("hidden")) return;
      closeDrawer();
    });

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== "class") return;
        if (menuWrapper.classList.contains("hidden")) {
          menuButton.setAttribute("aria-expanded", "false");
          resetSubToggles();
        }
      });
    }).observe(menuWrapper, {
      attributes: true,
      attributeFilter: ["class"],
    });
  })();

  // =========================
  // Pagination aria-labels
  // =========================
  (function () {
    var nav = document.querySelector(".sf-pagination");
    if (!nav) return;

    nav.setAttribute("role", "navigation");
    nav.setAttribute("aria-label", "Pagination");

    var prev = nav.querySelector('span.prev a, a[rel="prev"]');
    if (prev) prev.setAttribute("aria-label", "Go to previous page");

    var next = nav.querySelector('span.next a, a[rel="next"]');
    if (next) next.setAttribute("aria-label", "Go to next page");

    nav.querySelectorAll("span.page a").forEach(function (link) {
      var num = link.textContent.trim();
      if (num) link.setAttribute("aria-label", "Go to page " + num);
    });

    var current = nav.querySelector("span.page.current");
    if (current) {
      var num = current.textContent.trim();
      current.setAttribute("aria-current", "page");
      current.setAttribute("aria-label", "Page " + num);
    }
  })();

  //filter aria-expanded
  function initCustomSelectAria() {
    document
      .querySelectorAll(".sf__custom-select .select-selected")
      .forEach(function (el) {
        new MutationObserver(function () {
          el.setAttribute(
            "aria-expanded",
            el.classList.contains("select-arrow-active") ? "true" : "false",
          );
        }).observe(el, {
          attributes: true,
          attributeFilter: ["class"],
        });
      });
  }
  initCustomSelectAria();

  // =========================
  //slider for recently reviewd
  // =========================

  function initSliderAccessibility(slider) {
    function updateSlides() {
      const slides = slider.querySelectorAll(".swiper-slide");
      const activeSlide = slider.querySelector(".swiper-slide-active");

      if (!activeSlide) return;

      const activeIndex = [...slides].indexOf(activeSlide);

      slides.forEach((slide, index) => {
        const isVisible = index >= activeIndex && index <= activeIndex + 3;

        slide.setAttribute("aria-hidden", isVisible ? "false" : "true");

        slide
          .querySelectorAll("a, button, input, select, textarea")
          .forEach((el) => {
            if (isVisible) {
              if (!el.matches(".product-tile__overlay-link")) {
                el.removeAttribute("aria-hidden");
                el.removeAttribute("tabindex");
              }
            } else {
              el.setAttribute("aria-hidden", "true");
              el.setAttribute("tabindex", "-1");
            }
          });
      });
    }

    updateSlides();

    new MutationObserver(updateSlides).observe(slider, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  // Existing slider (load immediately)
  const recentlyViewed = document.querySelector(
    ".sf-product__section.recently-viewed .swiper-wrapper",
  );

  if (recentlyViewed) {
    initSliderAccessibility(recentlyViewed);
  }

  // Product recommendations (load with delay)
  setTimeout(() => {
    const recommendations = document.querySelector(
      ".sf-product__section.product-recommendations .swiper-wrapper",
    );

    if (recommendations) {
      initSliderAccessibility(recommendations);
    }
  }, 6000);

  //aria-selected for tabs
  document
    .querySelectorAll(".sf-tabs.sf-pdt__accordion .sf-tab-header")
    .forEach((tab) => tab.removeAttribute("tabindex"));
  document.querySelectorAll(".sf-tabs .sf-tab-header").forEach((tab) => {
    new MutationObserver(() => {
      tab.setAttribute("aria-selected", tab.classList.contains("active"));
    }).observe(tab, { attributes: true, attributeFilter: ["class"] });
  });
  //button label issue
  document
    .querySelectorAll(
      ".sf-custom__block.sf__about-block.sf__about-block-text .sf__btn.sf__btn-primary",
    )
    .forEach((btn) =>
      btn.setAttribute(
        "aria-label",
        "Apply now - focus will move to application form",
      ),
    );
  //tabindex and role on country swatcher
  (function () {
    const selectBox = document.querySelector(
      ".sf-currency-switcher  .sf__custom-select",
    );
    const selected = document.querySelector(
      ".sf-currency-switcher .sf__custom-select .select-selected",
    );
    const options = document.querySelectorAll(
      ".sf-currency-switcher .sf__custom-select .select-items.select-hide div",
    );

    if (!selectBox || !selected) return;

    // Add accessibility attributes to options
    selected.setAttribute("tabindex", "0");
    options.forEach(function (option) {
      option.setAttribute("role", "button");
      option.setAttribute("tabindex", "0");
    });

    // Add screen reader message
    const optionList = document.querySelector(
      ".sf__custom-select .select-items.select-hide",
    );

    if (optionList && !optionList.querySelector(".sr-only")) {
      const message = document.createElement("span");
      message.className = "sr-only";
      message.textContent =
        "Upon selecting an option, the page will be refreshed";
      optionList.prepend(message);
    }

    // Close dropdown on Escape
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        const activeSelect = document.querySelector(
          ".sf__custom-select .select-selected.select-arrow-active",
        );
        const dropdown = document.querySelector(
          ".sf__custom-select .select-items",
        );

        if (activeSelect) {
          activeSelect.classList.remove("select-arrow-active");
          setTimeout(function () {
            activeSelect.focus();
          }, 200);
        }

        if (dropdown) {
          dropdown.classList.add("select-hide");
        }
      }
    });
  })();

  //cart addons buttons focus managament
  (function () {
    let lastTrigger = null;

    function getFocusTarget(addon) {
      const focusable = addon.querySelector(
        'input:not([type="hidden"]), textarea, select, button, [href], [tabindex]:not([tabindex="-1"])',
      );
      if (focusable) return focusable;

      if (!addon.hasAttribute("tabindex")) addon.setAttribute("tabindex", "-1");
      return addon;
    }

    function openAddon(trigger) {
      const key = trigger.getAttribute("data-open");
      const addon = document.getElementById("scd-" + key);
      if (!addon) return;

      document.querySelectorAll(".scd__addon.open").forEach((el) => {
        if (el !== addon) el.classList.remove("open");
      });

      lastTrigger = trigger;
      addon.classList.add("open");
      getFocusTarget(addon).focus();
    }

    function closeAddon(addon) {
      if (!addon) return;
      addon.classList.remove("open");
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    document.addEventListener("click", (e) => {
      const openBtn = e.target.closest("[data-open]");
      if (openBtn) {
        openAddon(openBtn);
        return;
      }

      const cancelBtn = e.target.closest(".btn-cancel");
      if (cancelBtn) {
        closeAddon(cancelBtn.closest(".scd__addon"));
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" || e.key === "Esc") {
        const openAddonEl = document.querySelector(".scd__addon.open");
        if (openAddonEl) closeAddon(openAddonEl);
      }
    });
  })();

  //================= END ===============//
});
